var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.clickOutside,
          expression: "clickOutside",
        },
      ],
      staticClass: "dropdown",
    },
    [
      _c(
        "button",
        {
          staticClass: "btn dropdown-toggle btn-sm m-2",
          class: _vm.buttonActiveClass,
          attrs: {
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false",
          },
          on: {
            click: _vm.toggleMenu,
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "badge bg-dark mr-2 px-2 py-1",
            },
            [_vm._v(_vm._s(_vm.notifications))]
          ),
          _vm._v(_vm._s(_vm.label) + "\n  "),
        ]
      ),
      _vm._v(" "),
      _vm.showMenu
        ? _c(
            "ul",
            {
              staticClass: "dropdown-menu show",
            },
            _vm._l(_vm.items, function (item) {
              return _c(
                "li",
                {
                  key: item.id,
                  attrs: {
                    link: item.link,
                    text: item.text,
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      attrs: {
                        href: item.link,
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(item.text))]
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }